(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["personalized-home"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ceylera-personalized-home')) {
    customElements.define('ceylera-personalized-home', class extends HTMLElement {
      connectedCallback() {
        this.storageKey = 'ceylera-ritual-preference';
        this.visitKey = 'ceylera-returning-visitor';
        this.tabs = Array.from(this.querySelectorAll('[data-ritual-tab]'));
        this.panels = Array.from(this.querySelectorAll('[data-ritual-panel]'));
        this.headings = {
          tea: this.dataset.headingTea,
          spices: this.dataset.headingSpices,
          wellness: this.dataset.headingWellness,
          gifts: this.dataset.headingGifts
        };
        this.tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => this.select(tab.dataset.ritualTab, true));
          tab.addEventListener('keydown', event => this.onKeydown(event, index));
        });
        let preference = this.dataset.defaultRitual;
        try {
          preference = localStorage.getItem(this.storageKey) || preference;
          if (localStorage.getItem(this.visitKey)) {
            const fresh = this.querySelector('[data-new-visitor]');
            const returning = this.querySelector('[data-returning-visitor]');
            if (fresh && returning) {
              fresh.hidden = true;
              returning.hidden = false;
            }
          }
          localStorage.setItem(this.visitKey, 'true');
        } catch (error) {
          preference = this.dataset.defaultRitual;
        }
        this.select(preference, false);
      }

      select(ritual, save) {
        if (!this.tabs.some(tab => tab.dataset.ritualTab === ritual)) ritual = this.dataset.defaultRitual;
        this.tabs.forEach(tab => {
          const selected = tab.dataset.ritualTab === ritual;
          tab.setAttribute('aria-selected', String(selected));
          tab.tabIndex = selected ? 0 : -1;
        });
        this.panels.forEach(panel => { panel.hidden = panel.dataset.ritualPanel !== ritual; });
        const heading = this.querySelector('[data-recommendation-heading]');
        if (heading && this.headings[ritual]) heading.textContent = this.headings[ritual];
        if (save) {
          try { localStorage.setItem(this.storageKey, ritual); } catch (error) {}
        }
      }

      onKeydown(event, index) {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        let next = index;
        if (event.key === 'ArrowRight') next = (index + 1) % this.tabs.length;
        if (event.key === 'ArrowLeft') next = (index - 1 + this.tabs.length) % this.tabs.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = this.tabs.length - 1;
        this.tabs[next].focus();
        this.select(this.tabs[next].dataset.ritualTab, true);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-review-summary"] && !Shopify.designMode) return;
  try {
    
  function initializeProductReviews(scope) {
    scope.querySelectorAll('[data-product-reviews]').forEach(function (root) {
      if (root.dataset.reviewsReady) return;
      root.dataset.reviewsReady = 'true';
      var quotes = Array.from(root.querySelectorAll('.prs__quote'));
      var position = root.querySelector('[data-review-position]');
      var index = 0;
      var expand = root.querySelector('[data-review-expand]');
      var navigation = root.querySelector('[data-review-navigation]');
      if (expand) {
        expand.addEventListener('click', function () {
          var expanded = expand.getAttribute('aria-expanded') !== 'true';
          expand.setAttribute('aria-expanded', String(expanded));
          expand.textContent = expanded ? expand.dataset.labelCollapse : expand.dataset.labelExpand;
          root.querySelector('.prs__quotes').classList.toggle('prs__quotes--expanded', expanded);
          quotes.forEach(function (quote, quoteIndex) { quote.hidden = !expanded && quoteIndex !== index; });
          if (navigation) navigation.hidden = expanded;
          if (!expanded) expand.scrollIntoView({ block: 'nearest' });
        });
      }
      root.querySelectorAll('[data-review-direction]').forEach(function (button) {
        button.addEventListener('click', function () {
          if (quotes.length < 2) return;
          quotes[index].hidden = true;
          index = (index + (button.dataset.reviewDirection === 'next' ? 1 : -1) + quotes.length) % quotes.length;
          quotes[index].hidden = false;
          if (position) position.textContent = String(index + 1);
        });
      });
    });
  }
  initializeProductReviews(document);
  document.addEventListener('shopify:section:load', function (event) {
    initializeProductReviews(event.target);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-showcase"]) return;
  try {
    
  var mainImg = document.getElementById('PPMainImg');
  var blurImg = document.getElementById('PPBlurBg');

  document.querySelectorAll('.pp-thumb').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (mainImg) {
        mainImg.src = btn.dataset.src;
        mainImg.alt = btn.dataset.alt || mainImg.alt;
      }
      if (blurImg) {
        blurImg.src = btn.dataset.src;
      }
      document.querySelectorAll('.pp-thumb').forEach(function (thumb) {
        thumb.classList.remove('is-active');
        thumb.setAttribute('aria-pressed', 'false');
      });
      btn.classList.add('is-active');
      btn.setAttribute('aria-pressed', 'true');
    });
  });

  document.querySelectorAll('.ps__thumbs-nav').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var track = document.getElementById('PPThumbs');
      if (!track) {
        return;
      }
      var direction = btn.classList.contains('ps__thumbs-nav--prev') ? -1 : 1;
      track.scrollBy({ left: direction * 120, behavior: 'smooth' });
    });
  });

  var variantsData = [];
  var variantsEl = document.getElementById('ProductVariantsData');
  if (variantsEl) {
    try {
      variantsData = JSON.parse(variantsEl.textContent);
    } catch (error) {
      variantsData = [];
    }
  }

  function selectedOptions() {
    var options = [];
    document.querySelectorAll('.pp-option__pills').forEach(function (group) {
      var active = group.querySelector('.pp-pill.is-active');
      if (active) {
        options.push(active.dataset.value);
      }
    });
    return options;
  }

  function findSelectedVariant(options) {
    return variantsData.find(function (variant) {
      return variant.options.every(function (option, index) {
        return option === options[index];
      });
    });
  }

  function money(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function getPackageQuantity() {
    var qtyInput = document.getElementById('PPQty');
    var qty = qtyInput ? parseInt(qtyInput.value || '1', 10) : 1;
    return Number.isNaN(qty) ? 1 : Math.min(250, Math.max(1, qty));
  }

  function setPackageQuantity(quantity) {
    var qtyInput = document.getElementById('PPQty');
    var safeQuantity = Number.isNaN(quantity) ? 1 : Math.min(250, Math.max(1, quantity));
    if (qtyInput) {
      qtyInput.value = safeQuantity;
    }
    syncPackageSelection(safeQuantity);
    return safeQuantity;
  }

  function syncPackageSelection(quantity) {
    document.querySelectorAll('[data-package-qty]').forEach(function (item) {
      var itemQty = parseInt(item.dataset.packageQty || '0', 10);
      var isActive = itemQty === quantity;
      item.classList.toggle('is-active', isActive);
      item.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });
  }

  function currentVariant() {
    var variant = findSelectedVariant(selectedOptions());
    if (variant) {
      return variant;
    }
    return variantsData && variantsData.length ? variantsData[0] : null;
  }

  var foodMeta = document.getElementById('PPFoodMeta');

  function variantWithOption(value) {
    return variantsData.find(function (candidate) {
      return candidate.options && candidate.options[0] === value;
    }) || null;
  }

  function selectedPackLabel() {
    var selected = selectedOptions();
    var variant = currentVariant();
    var value = selected.length ? selected[0] : (variant && variant.options ? variant.options[0] : '');
    if (value === 'Default Title' || !value) return 'item';
    if (/^\d+$/.test(value)) return value + 'g';
    return value;
  }

  function selectedSellingPlan() {
    var form = document.getElementById('ProductForm');
    if (!form) return '';
    var input = form.querySelector('[name="selling_plan"]:checked, select[name="selling_plan"], input[type="hidden"][name="selling_plan"]:not(:disabled)');
    return input ? input.value : '';
  }

  function subscriptionAllocation(variant, planId) {
    if (planId === undefined) planId = selectedSellingPlan();
    return planId && variant && (variant.selling_plan_allocations || []).find(function (allocation) {
      return String(allocation.selling_plan_id) === String(planId);
    });
  }

  function packPlan(quantity, sellingPlanOverride) {
    var selected = currentVariant();
    if (!selected || selected.available === false) return null;
    var count = Math.min(250, Math.max(1, parseInt(quantity || 1, 10) || 1));
    var mode = foodMeta ? foodMeta.dataset.packMode : 'standard';
    var chosenOption = selectedPackLabel();
    var planId = sellingPlanOverride === undefined ? selectedSellingPlan() : String(sellingPlanOverride || '');
    var selectedAllocation = planId ? subscriptionAllocation(selected, planId) : null;
    if (planId && !selectedAllocation) return null;
    var tiers = [{units:1,variant:selected}];
    var cinnamon100g = mode === 'cinnamon' && chosenOption === '100g';
    var cinnamon50g = mode === 'cinnamon' && chosenOption === '50g';
    var bag15 = mode === 'bags' && chosenOption === '15 bags';

    if (cinnamon100g) {
      tiers = [
        {units:1,variant:variantWithOption('100g')},
        {units:2,variant:variantWithOption('200g') || variantWithOption('2 x 100g') || variantWithOption('2 × 100g packs')},
        {units:3,variant:variantWithOption('300g') || variantWithOption('3x 100g') || variantWithOption('3 × 100g packs')},
        {units:5,variant:variantWithOption('500g') || variantWithOption('5 x 100g') || variantWithOption('5 × 100g packs')}
      ];
    } else if (bag15) {
      tiers = [
        {units:1,variant:variantWithOption('15 bags')},
        {units:2,variant:variantWithOption('15 bags x 2')}
      ];
    }
    var best = new Array(count + 1);
    best[0] = { total:0, allocations:[] };
    for (var i=1; i<=count; i++) {
      for (var j=0; j<tiers.length; j++) {
        var tier=tiers[j];
        if (!tier.variant || !tier.variant.available || i<tier.units || !best[i-tier.units]) continue;
        var tierAllocation=planId ? subscriptionAllocation(tier.variant,planId) : null;
        if (planId && !tierAllocation) continue;
        var previous=best[i-tier.units];
        var tracked=tier.variant.inventory_management && tier.variant.inventory_policy!=='continue';
        if (tracked && Number.isFinite(Number(tier.variant.inventory_quantity))) {
          var alreadyAllocated=previous.allocations.reduce(function (count,item) {
            return count+(item.variant.id===tier.variant.id ? 1 : 0);
          },0);
          if (alreadyAllocated>=Number(tier.variant.inventory_quantity)) continue;
        }
        var candidate={total:previous.total+(tierAllocation ? tierAllocation.price : tier.variant.price),allocations:previous.allocations.concat([{units:tier.units,variant:tier.variant}])};
        if (!best[i] || candidate.total<best[i].total || (candidate.total===best[i].total && candidate.allocations.length<best[i].allocations.length)) {
          best[i]=candidate;
        }
      }
    }
    if (!best[count]) return null;
    var grouped={};
    best[count].allocations.forEach(function (tier) {
      var key=String(tier.variant.id);
      if (!grouped[key]) grouped[key]={id:Number(tier.variant.id),quantity:0,units:tier.units};
      grouped[key].quantity++;
    });
    var items=Object.keys(grouped).map(function (key) {
      var item=grouped[key];
      var line={id:item.id,quantity:item.quantity};
      if (cinnamon100g) line.properties={'Packed as':item.units+' × 100g individual packs'};
      if (bag15) line.properties={'Packed as':item.units+' × 15-bag packs'};
      return line;
    });
    var originalTotal=selected.price*count;
    var eligible=foodMeta && foodMeta.dataset.eligibleDiscount==='true' && count>=2;
    var unitPrice=selectedAllocation ? selectedAllocation.price : selected.price;
    var total=eligible ? (unitPrice-Math.floor(unitPrice*.1))*count : best[count].total;
    if (cinnamon50g) {
      var smallPackRate=count>=5 ? .04 : count>=3 ? .03 : count>=2 ? .02 : 0;
      total=(unitPrice-Math.floor(unitPrice*smallPackRate))*count;
    }
    if (planId) {
      var oneTimePlan=packPlan(count,'');
      if (!oneTimePlan || total>=oneTimePlan.total) return null;
    }
    return {items:items,total:total,original:originalTotal,quantity:count,pack:chosenOption,cinnamon100g:cinnamon100g,bag15:bag15,eligible:eligible};
  }


  function purchaseOptionAllocation(option, variant) {
    var select = option.querySelector('select.appstle_select, select[name="selling_plan"]');
    var input = option.querySelector('input[name="selling_plan"]:checked, input[name="selling_plan"]');
    var candidate = select && select.value ? select.value : input && input.value;
    var allocations = variant && variant.selling_plan_allocations || [];
    var allocation = allocations.find(function (entry) {
      return String(entry.selling_plan_id) === String(candidate);
    });
    if (!allocation && !/^\d+$/.test(String(candidate || ''))) allocation = allocations[0];
    return allocation || null;
  }

  function setPurchaseText(node, value) {
    if (node.textContent !== value) node.textContent = value;
  }

  function syncPurchaseOptionTotals() {
    var form = document.getElementById('ProductForm');
    var variant = currentVariant();
    if (!form || !foodMeta || !variant) return;
    var quantity = getPackageQuantity();
    form.querySelectorAll('.appstle_sub_widget .appstle_subscription_wrapper_option').forEach(function (option) {
      var recurring = option.classList.contains('appstle_include_dropdown');
      var host = option.querySelector(recurring ? '.appstle_subscription_amount_wrapper' : '.appstle_one_time_price_wrapper');
      if (!host) return;
      var allocation = recurring ? purchaseOptionAllocation(option, variant) : null;
      var plan = recurring ? allocation && packPlan(quantity, allocation.selling_plan_id) : packPlan(quantity, '');
      var total = host.querySelector('.ceylera-purchase-total');
      if (!total) {
        total = document.createElement('span');
        total.className = 'ceylera-purchase-total';
        var amount = document.createElement('strong');
        amount.className = 'ceylera-purchase-total__amount';
        var original = document.createElement('s');
        original.className = 'ceylera-purchase-total__original';
        var note = document.createElement('small');
        note.className = 'ceylera-purchase-total__note';
        total.appendChild(amount);
        total.appendChild(original);
        total.appendChild(note);
        host.appendChild(total);
      }
      if (host.dataset.ceyleraTotal !== 'true') host.dataset.ceyleraTotal = 'true';
      var amountNode = total.querySelector('.ceylera-purchase-total__amount');
      var originalNode = total.querySelector('.ceylera-purchase-total__original');
      var noteNode = total.querySelector('.ceylera-purchase-total__note');
      setPurchaseText(amountNode, plan ? money(plan.total) : foodMeta.dataset.unavailableNote);
      var hasSavings = !!plan && plan.original > plan.total;
      var originalText = hasSavings ? money(plan.original) : '';
      setPurchaseText(originalNode, originalText);
      if (originalNode.hidden !== !hasSavings) originalNode.hidden = !hasSavings;
      var regularLabel = (foodMeta.dataset.regularTotalNote || '').replace('[amount]', originalText);
      if (originalNode.getAttribute('aria-label') !== regularLabel) originalNode.setAttribute('aria-label', regularLabel);
      var template = recurring ? foodMeta.dataset.deliveryTotalNote : foodMeta.dataset.purchaseTotalNote;
      var noteText = (template || '').replace('[count]', String(quantity)).replace('[size]', selectedPackLabel());
      setPurchaseText(noteNode, noteText);
    });
  }

  var purchaseTotalSyncPending = false;
  function queuePurchaseOptionTotals() {
    if (purchaseTotalSyncPending) return;
    purchaseTotalSyncPending = true;
    window.requestAnimationFrame(function () {
      purchaseTotalSyncPending = false;
      syncPurchaseOptionTotals();
    });
  }

  function discountedTotal(basePrice, quantity) {
    return basePrice * quantity;
  }

  function refreshBulkSelections(quantity) {
    var root=document.getElementById('PPBulkChoices');
    var grid=document.getElementById('PPBulkGrid');
    if (!root || !grid || !foodMeta) return;
    var mode=foodMeta.dataset.packMode;
    var pack=selectedPackLabel();
    var cinnamonSmall=mode==='cinnamon' && pack!=='100g';
    var title=document.getElementById('PPBulkTitle');
    var intro=document.getElementById('PPBulkIntro');
    grid.hidden=false;
    if (title) title.textContent=selectedSellingPlan()?'Choose your delivery quantity':'The More You Buy, The More You Save';
    if (intro) {
      if (selectedSellingPlan()) intro.textContent=foodMeta.dataset.subscriptionPackIntro;
      else if (cinnamonSmall) intro.textContent=foodMeta.dataset.cinnamonSmallIntro;
      else if (mode==='cinnamon') intro.textContent='Choose a quantity to receive the existing 100g bundle pricing.';
      else if (mode==='bags') intro.textContent='15-bag teas have bundle savings in pairs. Choose the quantity that suits you.';
      else intro.textContent='Select a quantity below or adjust the number of packs. Total savings update automatically.';
    }
    var quantities=mode==='bags'?[1,2,4,6]:[1,2,3,5];
    var singlePlan=packPlan(1);
    grid.querySelectorAll('[data-bulk-qty]').forEach(function (button,index) {
      var requested=quantities[index];
      if (!requested) return;
      button.dataset.bulkQty=String(requested);
      var label=button.querySelector('[data-bulk-label]');
      var price=button.querySelector('[data-bulk-price]');
      var badge=button.querySelector('[data-bulk-badge]');
      if (label) label.textContent=requested+' '+(requested===1?'Pack':'Packs');
      var option=packPlan(requested);
      button.disabled=!option;
      if (price) price.textContent=option?money(option.total):'Unavailable';
      var note='';
      var regularTotal=singlePlan ? singlePlan.total*requested : 0;
      var hasSavings=option && singlePlan && option.total<regularTotal;
      if (hasSavings) {
        if (mode==='cinnamon' && pack==='100g') {
          if (requested===2) note='Value Pack';
          if (requested===3) note='Family Pack';
          if (requested===5) note='Best Value';
        } else if (mode==='bags') {
          if (requested===2) note='Best Value';
          if (requested===4) note='Family Pack';
          if (requested===6) note='Stock Up';
        } else {
          if (requested===2) note='Value Pack';
          if (requested===3) note='Family Pack';
          if (requested===5) note='Stock Up';
        }
      }
      if (badge) {badge.hidden=!note;badge.textContent=note;}
      var active=quantity===requested;
      button.classList.toggle('is-active',active);
      button.setAttribute('aria-pressed',active?'true':'false');
    });
  }

  document.querySelectorAll('[data-bulk-qty]').forEach(function (button) {
    button.addEventListener('click',function () {
      if (!foodMeta || button.disabled) return;
      var quantity=parseInt(button.dataset.bulkQty||'1',10);
      setPackageQuantity(quantity);
      var variant=currentVariant();
      if (variant && variant.price!=null) updateBuyingOptions(variant.price);
    });
  });

  function updateBuyingOptions(basePrice) {
    var qtyInput = document.getElementById('PPQty');
    var totalEl = document.querySelector('[data-buying-total]');
    var atcBtn = document.querySelector('.pp-atc');
    var quantity = getPackageQuantity();

    if (qtyInput) qtyInput.value = quantity;
    syncPackageSelection(quantity);

    if (foodMeta) {
      refreshBulkSelections(quantity);
      var plan=packPlan(quantity);
      var countEl=document.getElementById('PPPackCount');
      var foodTotalEl=document.getElementById('PPFoodTotal');
      var foodOriginalEl=document.getElementById('PPFoodOriginal');
      var compareEl=document.getElementById('PPFoodCompare');
      var bestBadge=document.getElementById('PPFoodBestValue');
      if (plan) {
        var onePackName=plan.pack==='item'?'item':plan.pack+' pack';
        if (countEl) countEl.textContent=plan.quantity+' × '+onePackName+(plan.quantity>1?'s':'')+(plan.cinnamon100g?' · '+(plan.quantity*100)+'g total':'');
        if (foodTotalEl) foodTotalEl.textContent=money(plan.total);
        if (compareEl) compareEl.hidden=!(plan.total<plan.original);
        if (foodOriginalEl) foodOriginalEl.textContent=money(plan.original);
        if (bestBadge) bestBadge.hidden=!(plan.cinnamon100g && plan.quantity%5===0 || plan.bag15 && plan.quantity>=2 && plan.quantity%2===0);
        if (atcBtn) {
          atcBtn.disabled=false;
          atcBtn.textContent='Add to Cart - '+money(plan.total);
        }
      } else {
        if (countEl) countEl.textContent='Not available in this quantity';
        if (compareEl) compareEl.hidden=true;
        if (bestBadge) bestBadge.hidden=true;
        if (atcBtn) {atcBtn.disabled=true;atcBtn.textContent='Unavailable';}
      }
      syncPurchaseOptionTotals();
      return;
    }

    document.querySelectorAll('[data-package-total]').forEach(function (item) {
      var packageQty=parseInt(item.dataset.packageQtyValue||'1',10);
      item.textContent=money(discountedTotal(basePrice,packageQty));
    });
    document.querySelectorAll('[data-package-original]').forEach(function (item) {
      var packageQty=parseInt(item.dataset.packageQtyValue||'2',10);
      item.textContent=money(basePrice*packageQty);
    });
    if (totalEl) totalEl.textContent=money(discountedTotal(basePrice,quantity));
    if (atcBtn && !atcBtn.disabled) atcBtn.textContent='Add to Cart - '+money(discountedTotal(basePrice,quantity));
  }

  function updateVariant() {
    var variant = findSelectedVariant(selectedOptions());
    if (!variant) {
      return;
    }

    var variantInput = document.getElementById('ProductVariantId');
    var priceEl = document.getElementById('ProductPrice');
    var compareEl = document.querySelector('.product-page__price-compare');
    var atcBtn = document.querySelector('.pp-atc');

    if (variantInput) {
      var previousVariantId = variantInput.value;
      variantInput.value = variant.id;
      if (String(previousVariantId) !== String(variant.id)) variantInput.dispatchEvent(new Event('change', {bubbles:true}));
    }

    if (priceEl && variant.price != null) {
      priceEl.textContent = money(variant.price);
    }

    if (compareEl) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        compareEl.textContent = money(variant.compare_at_price);
        compareEl.style.display = '';
      } else {
        compareEl.style.display = 'none';
      }
    }

    if (atcBtn) {
      if (variant.available) {
        atcBtn.disabled = false;
        updateBuyingOptions(variant.price);
      } else {
        atcBtn.disabled = true;
        atcBtn.textContent = 'Sold Out';
      }
    }
  }

  document.querySelectorAll('.pp-option__pills').forEach(function (group) {
    group.querySelectorAll('.pp-pill').forEach(function (pill) {
      pill.addEventListener('click', function () {
        group.querySelectorAll('.pp-pill').forEach(function (item) {
          item.classList.remove('is-active');
        });
        pill.classList.add('is-active');
        updateVariant();
      });
    });
  });

  document.querySelectorAll('[data-package-qty]').forEach(function (button) {
    button.addEventListener('click', function () {
      var packageQty = parseInt(button.dataset.packageQty || '1', 10);
      setPackageQuantity(packageQty);

      var variant = currentVariant();
      if (variant && variant.price != null) {
        updateBuyingOptions(variant.price);
      }
    });
  });

  document.querySelectorAll('[data-subscribe-option]').forEach(function (button) {
    button.addEventListener('click', function () {
      var sellingPlanInput = document.getElementById('ProductSellingPlan');
      var active = button.classList.toggle('is-active');
      button.setAttribute('aria-pressed', active ? 'true' : 'false');

      if (sellingPlanInput) {
        sellingPlanInput.disabled = !active;
        sellingPlanInput.value = active ? button.dataset.sellingPlanId || '' : '';
      }
    });
  });

  var buyingOptions = document.querySelector('[data-buying-options]');
  if (foodMeta) {
    document.querySelectorAll('.pp-option__pills:not([hidden])').forEach(function (group) {
      if (!group.querySelector('.pp-pill.is-active')) {
        var first=group.querySelector('.pp-pill');
        if (first) first.classList.add('is-active');
      }
    });
    updateVariant();
    var firstPack=currentVariant();
    if (firstPack) updateBuyingOptions(firstPack.price);
  } else if (buyingOptions) {
    var basePrice = parseInt(buyingOptions.dataset.basePrice || '0', 10);
    if (!Number.isNaN(basePrice)) updateBuyingOptions(basePrice);
  }

  document.querySelectorAll('.qty-selector__btn--minus').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var input = document.getElementById('PPQty');
      var variant = currentVariant();
      if (!input) {
        return;
      }
      setPackageQuantity(parseInt(input.value || '1', 10) - 1);
      if (variant && variant.price != null) {
        updateBuyingOptions(variant.price);
      }
    });
  });

  document.querySelectorAll('.qty-selector__btn--plus').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var input = document.getElementById('PPQty');
      var variant = currentVariant();
      if (!input) {
        return;
      }
      setPackageQuantity(parseInt(input.value || '1', 10) + 1);
      if (variant && variant.price != null) {
        updateBuyingOptions(variant.price);
      }
    });
  });

  var quantityInput = document.getElementById('PPQty');
  if (quantityInput) {
    quantityInput.addEventListener('input', function () {
      var variant = currentVariant();
      setPackageQuantity(parseInt(quantityInput.value || '1', 10));
      if (variant && variant.price != null) {
        updateBuyingOptions(variant.price);
      }
    });
    quantityInput.addEventListener('change', function () {
      var variant = currentVariant();
      setPackageQuantity(parseInt(quantityInput.value || '1', 10));
      if (variant && variant.price != null) {
        updateBuyingOptions(variant.price);
      }
    });
  }

  function refreshSubscriptionPrice() {
    var variant = currentVariant();
    if (variant) updateBuyingOptions(variant.price);
  }
  ['AppstleSubscription:SubscriptionWidget:SellingPlanSelected',
   'AppstleSubscription:SubscriptionWidget:SellingPlanDeSelected',
   'AppstleSubscription:SubscriptionWidget:sellingPlanChanged'].forEach(function (eventName) {
    document.addEventListener(eventName, function () { window.setTimeout(refreshSubscriptionPrice, 0); });
  });
  var productForm = document.getElementById('ProductForm');
  if (productForm) productForm.addEventListener('change', function (event) {
    if (event.target.name === 'selling_plan') refreshSubscriptionPrice();
  });
  if (productForm && foodMeta) {
    var purchaseOptionObserver = new MutationObserver(queuePurchaseOptionTotals);
    purchaseOptionObserver.observe(productForm, {childList:true,subtree:true,characterData:true});
    productForm.addEventListener('change', queuePurchaseOptionTotals);
    queuePurchaseOptionTotals();
    window.addEventListener('pageshow', queuePurchaseOptionTotals);
  }
  if (productForm) {
    productForm.addEventListener('submit', function (event) {
      event.preventDefault();

      var atcBtn = productForm.querySelector('[name="add"]');
      var variantInput = document.getElementById('ProductVariantId');
      var qtyInput = document.getElementById('PPQty');
      var variantId = parseInt(variantInput ? variantInput.value : '', 10);
      var quantity = getPackageQuantity();
      var addStatus = document.getElementById('PPAddStatus');
      if (addStatus) { addStatus.hidden = true; addStatus.textContent = ''; }
      var foodOrder = foodMeta ? packPlan(quantity) : null;

      if (Number.isNaN(variantId)) {
        if (addStatus) { addStatus.textContent = 'Please select an available option.'; addStatus.hidden = false; }
        return;
      }
      if (foodMeta && !foodOrder) {
        if (addStatus) { addStatus.textContent = 'That pack quantity is not available. Please choose a smaller quantity or another pack size.'; addStatus.hidden = false; }
        return;
      }

      if (atcBtn) {
        atcBtn.disabled = true;
        atcBtn.textContent = 'Adding...';
      }

      fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify((function () {
          var payload = foodMeta ? { items: foodOrder.items } : { id: variantId, quantity: quantity };
          var sellingPlanId = selectedSellingPlan();
          if (sellingPlanId) {
            if (payload.items) {
              payload.items.forEach(function (item) {item.selling_plan=sellingPlanId;});
            } else {
              payload.selling_plan=sellingPlanId;
            }
          }
          return payload;
        }()))
      }).then(function (response) {
        if (!response.ok) {
          throw new Error('cart add failed');
        }
        if (atcBtn) {
          atcBtn.textContent = 'Added';
          setTimeout(function () {
            atcBtn.disabled = false;
            var variant = currentVariant();
            if (variant && variant.price != null) {
              updateBuyingOptions(variant.price);
            } else {
              atcBtn.textContent = atcBtn.dataset.originalText || 'Add to Cart';
            }
          }, 1500);
        }
        if (window.openCartDrawer) {
          window.openCartDrawer();
        } else if (window.refreshCartCount) {
          window.refreshCartCount();
        }
      }).catch(function () {
        if (atcBtn) {
          atcBtn.disabled = false;
          atcBtn.textContent = 'Add to Cart';
        }
        if (addStatus) { addStatus.textContent = 'We could not add those packs to your cart. Please try a smaller quantity or try again.'; addStatus.hidden = false; }
        if (window.refreshCartCount) window.refreshCartCount();
      });
    });
  }

  } catch(e) { console.error(e); }
})();
})();
